import React, { useState, useRef, useEffect } from 'react'
import { ReactComponent as RightArrow } from '../../icon/right-arrow.svg'
import { ReactComponent as LeftArrow } from '../../icon/left-arrow.svg'
import Theme from '../../library/Theme'

interface BackgroundToolbarProps {
  theme: Theme
  backgroundUrls: string[]
  selectedIndex: number
  handleSelect: (index: number) => void
}

function BackgroundToolbar({ theme, backgroundUrls, selectedIndex, handleSelect }: BackgroundToolbarProps) {
  const [showControls, setShowControls] = useState(true)
  const [enableLeftControl, setEnableLeftControl] = useState(false)
  const [enableRightControl, setEnableRightControl] = useState(false)
  const toolbarRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    updateControls()
  })

  const scroll = (x: number) => {
    if (!toolbarRef.current) {
      return
    }
    toolbarRef.current.scrollLeft += x
  }

  const updateControls = () => {
    let toolbar = toolbarRef.current
    if (!toolbar) {
      return
    }

    setEnableLeftControl(toolbar && toolbar.scrollLeft > 0)
    setEnableRightControl(toolbar && toolbar.scrollLeft + toolbar.clientWidth < toolbar.scrollWidth)
    setShowControls(toolbar.clientWidth < toolbar.scrollWidth)
  }

  const scrollAmount = toolbarRef.current ? toolbarRef.current.clientWidth / 2 : 100

  return (
    <div className="toolbarContainer">
      {showControls &&
        <div className={"controlButton" + (enableLeftControl ? "" : " disabled")} style={theme.buttonStyle} onClick={(x) => scroll(-scrollAmount)}>
          <LeftArrow style={theme.svgStyle} />
        </div>
      }
      <div ref={toolbarRef} className="toolbar" onScroll={updateControls}>
        {backgroundUrls.map((backgroundUrl, index) =>
          <img
            crossOrigin="anonymous"
            className="toolbarItem"
            key={index}
            src={backgroundUrl}
            alt={"Background " + index}
            style={index === selectedIndex ? theme.toolbarSelectedImageStyle : {}}
            onLoad={updateControls}
            onClick={(e) => handleSelect(index)}
          />
        )}
      </div>

      {showControls &&
        <div className={"controlButton" + (enableRightControl ? "" : " disabled")} style={theme.buttonStyle} onClick={(x) => scroll(scrollAmount)}>
          <RightArrow style={theme.svgStyle} />
        </div>
      }
    </div>
  )
}

export default BackgroundToolbar
